import { useGetDiversificationSchemesQuery } from '@/store/diversificationsApi';

const usePortfolioDiversificationCategories = () => {
  const {
    data: allDiversifications,
    isLoading: allDiversificationsLoading,
    isError: allDiversificationsError,
  } = useGetDiversificationSchemesQuery({
    hideToBeClassified: true,
  });

  return {
    allDiversifications,
    allDiversificationsLoading,
    allDiversificationsError,
  };
};

export default usePortfolioDiversificationCategories;
